const { getLanguage } = require('core/i18n').i18n;

const localizationParser = {
    de: 'de-DE',
    en: 'en-ES',
    es: 'es-ES',
    nl: 'nl-NL',
    pt: 'pt-PT',
};

const getFormattedLanguage = (language = getLanguage()) =>
    localizationParser[language] || 'es-ES';

module.exports = {
    getFormattedLanguage,
};
